<template>
    <div class="inner-modal">
        <div class="inner-modal inner-modal--CM">
            <div class="inner-modal--CM-body">
                <!-- <div class="inner-modal--header">
                    <h3></h3>
                </div> -->
                <p>{{ compatibilityModalMessage }}</p>
            </div>

            <div class="modal-actions"><Cta type="primary" label="Continue" size="lg" @onClick="handleContinue"> </Cta> <Cta type="outline" label="Cancel" size="lg" @onClick="closeModal"> </Cta></div>
        </div>
        <button @click="closeModal" class="inner-modal__close">&times;</button>
    </div>
</template>

<script setup lang="ts">
import Cta from '../Cta.vue';
import { useStore } from 'vuex';

const props = defineProps({
    categoryType: String,
    selection: Object,
    handleContinueSelection: Function,
    compatibilityModalMessage: String,
});
const store = useStore();
const closeModal = async() => {
    await store.dispatch('closeModal');
};
const handleContinue = async() => {
    props.handleContinueSelection(props.selection, true);
    await store.dispatch('closeModal');
};
</script>
